import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Pagination,
  SnackbarContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "./ViewJob.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  useBindingEditJobPostingMutation,
  useDeleteEventHistoryMutation,
  useEventDropDownQuery,
  useEventsHistoryMutation,
  useExcelDataForProfileMatchMutation,
  useExcelDownloadQuery,
  useGetMailContentMutation,
  useGetMailJobDescriptionMutation,
  useMatchProfileListMutation,
  useProfileZipProcessMutation,
  useSendEmailforSubmittedClientMutation,
  useSendEmailJobDescriptionMutation,
  useSendEmailReferralJobMutation,
  useUnassignProfileMutation,
} from "../../redux/jobpostings/jobpostings.api";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import AddIcon from "@mui/icons-material/Add";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import Dropdown from "../../reusable_components/components/Dropdown";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";
import TopicIcon from "@mui/icons-material/Topic";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Loader from "../../reusable_components/components/Loader";
import theme from "../../theme/theme";
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import RefreshIcon from "../../assets/Icons/RefreshIcon";
import UsersXIcon from "../../assets/Icons/UnAssignProfileIcon";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import ShareIcon from "@mui/icons-material/Share";
import LinkIcon from "@mui/icons-material/Link";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import TelegramIcon from "@mui/icons-material/Telegram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RedditIcon from "@mui/icons-material/Reddit";
import CheckIcon from "@mui/icons-material/Check";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { TbCurrencyDollarCanadian } from "react-icons/tb";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import { TbCurrencyDirham } from "react-icons/tb";

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  RedditShareButton,
} from "react-share";
import ReactMarkdown from "react-markdown";

const ViewJob = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const id = +params?.id;
  const theme1 = useTheme();
  const isSmallScreen = useMediaQuery(theme1.breakpoints.down("md"));

  const { Snackbar } = useContext(SnackbarContext);

  const { Profile } = useSelector((state) => state.common);
  const userRole = Profile?.profile?.role;
  const isExternal = Profile?.profile?.isExternalRecruiter;

  const [value, setValue] = useState("1");
  // const mediaQuery = useMediaQuery('max-width:300%')

  const { position, name, isReferrals, isReferral, isEdit } =
    location?.state || "";
  const { positionTitle, activeTab, findProfile } = location?.state || "";
  const { positionName, isDashboard } = location?.state || "";
  const searchParams = new URLSearchParams(location.search);
  const jobPostingName = searchParams.get("jobPostingName");

  const searchParamsClientName = new URLSearchParams(location.search);
  const clientNameManageEventReport = searchParams.get("clientName");

  const path = location?.pathname.split("/");
  const pathName = path[1];

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateEmails = (emails) => {
    if (!emails) return false;
    const emailList = emails.split(/[,;]/).map((email) => email.trim());
    return emailList.every((email) => validateEmail(email));
  };

  const [isEmailValid, setIsEmailValid] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNavigateBack = () => {
    // if (userRole === "recruiter" && isReferrals === true) {
    //     navigate('/refer-jobs')
    // }
    // else if (isReferrals === true) {
    //     navigate('/referrals')
    // }
    // else if (isDashboard === true) {
    //     navigate('/dashboard')
    // }
    // else if(findProfile === true){
    //     navigate(`/submitprofiles/${profileId}`)
    // }
    // else {
    //     navigate('/jobpost')
    // }
    navigate(-1);
  };

  // APIs
  const [getMailJobDescription] = useGetMailJobDescriptionMutation();
  const [sendEmailJobDescription] = useSendEmailJobDescriptionMutation();
  const [JobPostingDetailsByPositionId, { data: bindingEditJobPosting }] =
    useBindingEditJobPostingMutation();
  const { data: eventDropDown } = useEventDropDownQuery();
  const [matchProfileList] = useMatchProfileListMutation();
  const [unassignProfile, { data: unassignProfileDatas }] =
    useUnassignProfileMutation();
  const [getMailContent] = useGetMailContentMutation();
  const [ExcelDataForProfileMatch] = useExcelDataForProfileMatchMutation();
  const [deleteEventHistory] = useDeleteEventHistoryMutation();
  const [sendEmailforSubmittedClient] =
    useSendEmailforSubmittedClientMutation();
  const [eventsHistory] = useEventsHistoryMutation();
  const [getProfiles] = useProfileZipProcessMutation();

  const [badgeMessages, setBadgeMessages] = useState([]);
  const [accordionOpen, setAccordionOpen] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [title, setTitle] = useState("");
  const [clientName, setClientName] = useState("");

  // const [currentUrl, setCurrentUrl] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [getJdList, setJdList] = useState([]);

  const getJdEmail = async (social) => {
    if (social?.label === "Email") {
      setOpenShareDialog(false);
      handleMailDialogOpen();
      try {
        const payload = {
          positionId: id,
        };
        const response = await getMailJobDescription(payload).unwrap();
        if (response?.status === 200) {
          setJdList(response?.response);
          setMailSubject(response?.response?.Subject);
          setMailBodycontent(response?.response?.htmlBody);
          setMailTo(response?.response?.To);
        }
      } catch (error) {
        Snackbar("Network error", "error");
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    setValue(activeTab || value);
  }, [activeTab]);

  const jobDescription =
    bindingEditJobPosting?.response?.data[0]?.jobDescription;
  const currentUrl = jobDescription;

  const copyCurrentPath = () => {
    const path = window.location.href;
    navigator.clipboard
      .writeText(path)
      .then(() => {
        Snackbar(`Link Copied : ${path}`, "success");
        setOpenShareDialog(false);
      })
      .catch((err) => {
        Snackbar("Failed to copy", "error");
        setOpenShareDialog(false);
      });
  };

  const socialIcons = [
    { icon: <LinkIcon />, label: "Copy link", onClick: copyCurrentPath },
    { component: EmailShareButton, icon: <EmailIcon />, label: "Email" },
    {
      component: WhatsappShareButton,
      icon: <WhatsAppIcon />,
      label: "Whatsapp",
    },
    // { component: FacebookShareButton, icon: <FacebookIcon />, label: "Facebook" },
    { component: TwitterShareButton, icon: <TwitterIcon />, label: "X" },
    // { component: TelegramShareButton, icon: <TelegramIcon />, label: "Telegram" },
    // { component: LinkedinShareButton, icon: <LinkedInIcon />, label: "LinkedIn" },
  ];

  const [openShareDialog, setOpenShareDialog] = useState(false);
  const handleCloseShare = () => {
    setOpenShareDialog(false);
  };

  const handleShare = () => {
    setOpenShareDialog(true);
  };

  const toggleReadMore = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    const payload = {
      positionId: id,
    };
    JobPostingDetailsByPositionId(payload);
  }, []);

  useEffect(() => {
    if (bindingEditJobPosting) {
      const title = bindingEditJobPosting?.response?.data[0]?.positionTitle;
      const clientName = bindingEditJobPosting?.response?.data[0]?.clientName;
      setTitle(title);
      setClientName(clientName);
    }
  }, [bindingEditJobPosting]);

  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const [eventType, setEventType] = useState("");
  const [profileId, setProfileId] = useState("");
  const [searchProfiles, setSearchProfiles] = useState("");
  const [profileListDatas, setProfileListDatas] = useState([]);
  const [profileList, setProfileList] = useState(true);
  const [profileListDatas_2, setProfileListDatas_2] = useState([]);
  const [profileMatchDatas, setProfileMatchDatas] = useState([]);
  const [openMailDialog, setOpenMailDialog] = useState(false);
  const [mailSubject, setMailSubject] = useState("");
  const [mailBodycontent, setMailBodycontent] = useState("");
  const [mailTo, setMailTo] = useState("");
  const [excelPath, setExcelPath] = useState("");
  const [zipFile, setZipFile] = useState("");
  const [profileZip, setProfileZip] = useState("");
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [historyTableDatas, setHistoryTableDatas] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState([]);
  const [profileMatchId, setProfileMatchId] = useState();
  const [days, setDays] = useState([]);

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "color",
    "background",
    "list",
    "bullet",
    "indent",
    "align",
    "script",
    "link",
    "image",
    "size",
  ];

  const toolBarOptions = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, false] }, { font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image"],
      ["clean"],
      // ['undo', 'redo'],
    ],
  };

  const handlePageChange = (e, newvalue) => {
    setPage(newvalue);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleEventTypeChange = (value) => {
    setEventType(value);
  };

  const handleHistoryDialogOpen = (item) => {
    setProfileId(item?.profileId);
    setHistoryDialogOpen(true);
  };

  const handleMailDialogClose = () => {
    setOpenMailDialog(false);
    setMailBodycontent("");
    setMailTo("");
    setExcelPath("");
    setZipFile("");
  };

  const handleHistoryDialogClose = () => {
    setHistoryDialogOpen(false);
  };

  const handleMailDialogOpen = () => {
    setOpenMailDialog(true);
  };

  const handleMailToChange = (e) => {
    const value = e.target.value;
    setMailTo(value);
    setIsEmailValid(validateEmails(value));
  };

  const handleMailSubjectChange = (e) => {
    const value = e.target.value;
    setMailSubject(value);
  };

  const handleBodyContentChange = (value) => {
    setMailBodycontent(value);
  };

  const handleEditCandidateNav = (item) => {
    window.open(`/editcandidateprofile/${item?.profileId}`, "_blank");
  };

  const handleNavigateFindprofile = (item) => {
    localStorage.removeItem("addProfileSearch");
    navigate(`/findprofile/${id}`, {
      state: {
        id: id,
        title: position ? position : title,
        name: name ? name : clientName,
      },
    });
  };

  const status = bindingEditJobPosting?.response?.data?.map(
    (data) => data?.status
  );

  const hanldeManageEventsNav = () => {
    if (isReferrals === true) {
      navigate(`/referrals/jobpostedit/${id}`, {
        state: {
          isReferrals: true,
        },
      });
    } else {
      navigate(`/manage-events/${id}`, {
        state: {
          id: id,
          submitProfilePath: window.location.pathname,
          title: title,
          name: name ? name : clientName,
          positionStatus: status,
        },
      });
    }
  };

  const hanldeMiniDialogOpen = (item) => {
    setMinihistoryDialogOpen(true);
    setDeleteId(item?.eventHistoryId);
    setProfileMatchId(item?.profileMatchId);
  };

  const handleCloseDelete = () => {
    setMinihistoryDialogOpen(false);
  };

  const handleProfileCheckbox = (profileMatchId) => {
    setProfileMatchDatas((prev) =>
      prev?.includes?.(profileMatchId)
        ? prev?.filter((id) => id !== profileMatchId)
        : [...prev, profileMatchId]
    );
  };

  const handleSearchProfileChange = (e) => {
    const value = e.target.value;
    setSearchProfiles(value);
  };

  const handleUnassignProfile = async (item) => {
    try {
      const payload = {
        jobPostId: id,
        profile: [item?.profileId],
      };
      setShowLoader(true);
      const response = await unassignProfile(payload).unwrap();
      setShowLoader(false);

      if (response?.status === 200) {
        Snackbar(response?.response?.message, "success");
      }
    } catch (err) {
      Snackbar("Network error", "error");
      setShowLoader(false);
    }
  };

  const handleMailContent = async () => {
    try {
      handleMailDialogOpen();
      const payload = {
        profMatchId: profileMatchDatas,
      };

      const response = await getMailContent(payload).unwrap();
      if (response?.status === 200) {
        setMailSubject(response?.response?.Subject);
        setMailBodycontent(response?.response?.bodyContent);
        setMailTo(response?.response?.To);
      }

      const excelResponse = await ExcelDataForProfileMatch(payload).unwrap();
      if (excelResponse?.status === 200) {
        const path = excelResponse?.response?.zipFile;
        setZipFile(path);
      }

      const profileResponse = await getProfiles(payload).unwrap();
      if (response?.status === 200) {
        setProfileZip(profileResponse?.profileZipFile);
      }
    } catch (err) {
      Snackbar("Network error", "error");
    }
  };

  const handleProfileMatchExcelDownload = async () => {
    try {
      const payload = {
        eventTypeId: eventType || 0,
        positionId: id,
        profileKeyword: searchProfiles || "",
      };

      const token = localStorage.getItem("token");
      const response = await fetch(
        window.REACT_APP_BASE_URL + `profileMatchListExcelFileDownload`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Matched Profile Details.xlsx");
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (err) {
      Snackbar("Network error", "error");
    }
  };

  const handleExcelDownload = async () => {
    const filePath = zipFile;
    const name = filePath?.substring(filePath?.lastIndexOf("/") + 1);
    const downloadUrl = `${window.REACT_APP_FILEDOWNLOAD_URL}:8444/Openrecruiter/API/download/report/${name}`;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download error:", err);
      Snackbar("Failed to download the file", "error");
    }
  };

  const handleZipFileDownload = async () => {
    const filePath = profileZip;
    const name = filePath?.substring(filePath?.lastIndexOf("/") + 1);
    const downloadUrl = `${window.REACT_APP_FILEDOWNLOAD_URL}:8444/Openrecruiter/API/download/report/${name}`;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download error:", err);
      Snackbar("Failed to download the file", "error");
    }
  };

  const handleZipDownload = () => {
    const filepath = profileZip;
    const name = filepath?.substring(filepath?.lastIndexOf("/") + 1);
    const unwantedPart = "/var/www/dev-or.g-axis.in/html";
    const cleanPath = filepath.replace(unwantedPart, ""); // Fix applied
    const url = `${window.REACT_APP_FILEDOWNLOAD_URL}/${cleanPath}`;

    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const downloadZip = () => {
  //     const filepath = profileZip;

  //     const name = filepath?.substring(filepath?.lastIndexOf('/') + 1);
  //     const unwantedPart = '/var/www/dev-or.g-axis.in/html';
  //     const cleanPath = filepath.replace(unwantedPart, '');
  //     const url = `${window.REACT_APP_FILEDOWNLOAD_URL}/${cleanPath}`;

  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = name;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  // };

  const handleHistoryDelete = async (item) => {
    try {
      const payload = {
        eventHistoryIds: [deleteId],
        profileMatchId: profileMatchId,
      };

      const response = await deleteEventHistory(payload).unwrap();

      if (response?.status === 200) {
        Snackbar("The History deleted successfully", "success");
        handleHistoryDialogClose();
        handleCloseDelete();
      }
    } catch (err) {
      Snackbar("Network error", "error");
    }
  };

  const handleSendEmailToClient = async () => {
    if (profileZip && zipFile) {
      try {
        const payload = {
          excelSheetPath: zipFile,
          htmlBody: mailBodycontent,
          subject: mailSubject,
          toMails: mailTo,
          zipPath: profileZip,
        };
        setShowLoader(true);
        const response = await sendEmailforSubmittedClient(payload).unwrap();
        setShowLoader(false);

        if (response?.status === 200) {
          Snackbar("Mail Sent Sucessfully", "success");
          handleMailDialogClose();
          setMailBodycontent("");
          setMailTo("");
          setProfileMatchDatas([]);
          setExcelPath("");
          setZipFile("");
        }
      } catch (err) {
        Snackbar("Network error", "error");
        setShowLoader(false);
      }
    } else {
      try {
        const payload = {
          htmlBody: getJdList?.htmlBody,
          subject: mailSubject,
          toMails: mailTo,
        };
        setShowLoader(true);
        const response = await sendEmailJobDescription(payload).unwrap();
        setShowLoader(false);

        if (response?.status === 200) {
          Snackbar("Mail Sent Sucessfully", "success");
          handleMailDialogClose();
          setProfileMatchDatas([]);
          setMailBodycontent("");
          setMailTo("");
          setExcelPath("");
          setZipFile("");
        }
      } catch (err) {
        Snackbar("Network error", "error");
        setShowLoader(false);
      }
    }
  };

  useEffect(() => {
    const getHistoryTable = async () => {
      try {
        const payload = {
          page: page - 1,
          size: 5000,
          positionId: id,
          profileId: profileId,
        };

        if (historyDialogOpen) {
          const response = await eventsHistory(payload).unwrap();
          if (response?.status === 200) {
            setHistoryTableDatas(response?.response?.eventHistory);
          }
        }
      } catch (err) {
        Snackbar("Network error", "error");
      }
    };
    getHistoryTable();
  }, [eventsHistory, historyDialogOpen, MinihistoryDialogOpen]);

  const badgeGroupMsgs = {
    "profile identified": "Needs Decision",
    "scheduled (internal)": "Yet to conduct Interview",
    "selected (internal)": "Waiting for Submitting to client",
    "rejected (internal)": "Rejected by Internal",
    "submitted to client": "Waiting for Client's Decision",
    "scheduled (client)": "Waiting for Client's Decision",
    "rejected (client)": "Rejected by Client",
    "selected (client)": "Waiting for candidate's Decision",
    offered: "Offer Acceptance Pending",
    joined: "Candidate joined",
    declined: "Declined by Candidate",
    "candidate not interested": "Candidate Not Intereseted",
    "on hold": "On hold by Internal",
    "pending client feedback": "Waiting for client's feedback",
  };

  useEffect(() => {
    const filterProfileList = async () => {
      try {
        const payload = {
          eventTypeId: eventType || 0,
          page: page - 1,
          positionId: id,
          profileKeyword: searchProfiles || "",
          size: rowsPerPage,
        };

        if (id) {
          const response = await matchProfileList(payload).unwrap();
          if (response) {
            const datas = response?.response?.data || [];
            if (profileList) {
              setProfileListDatas(datas);
              setProfileListDatas_2(datas);
              setProfileList(false);
            } else {
              setProfileListDatas_2(datas);
              setTotalCount(response?.response?.totalCount);
            }
          }
          const dates = response?.response?.data?.map(
            (item) => item?.eventDate
          );
          const days = dates?.map((item) => {
            const currentDate = dayjs();
            const eventDate = dayjs(item, "YYYY-MM-DD");
            const diff = currentDate.diff(eventDate, "day");
            return {
              day: diff || "0",
            };
          });
          setDays(days);

          const badgeMessages = response?.response?.data?.map((item) => {
            const eventType = item?.eventType?.toLowerCase();
            return {
              type: eventType,
              message: badgeGroupMsgs[eventType],
            };
          });
          setBadgeMessages(badgeMessages);
        }
      } catch (err) {
        alert("Network error", "error");
      }
    };
    filterProfileList();
  }, [
    matchProfileList,
    searchProfiles,
    eventType,
    unassignProfileDatas,
    page,
    rowsPerPage,
    value,
  ]);

  const handleExpandAccordion = (index) => {
    const actualIndex = (page - 1) * rowsPerPage + index;

    setAccordionOpen((prev) =>
      prev?.includes?.(actualIndex)
        ? prev?.filter((id) => id !== actualIndex)
        : [...prev, actualIndex]
    );
  };

  const handleDownloadProfile = (item) => {
    const profilePath = item?.cVPath;
    if (profilePath !== null) {
      const extension = profilePath
        .substring(profilePath?.lastIndexOf(".") + 1)
        .toLowerCase();
      const name = profilePath.substring(profilePath?.lastIndexOf("/") + 1);
      if (extension === "docx" || extension === "doc") {
        const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${profilePath}`;
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (extension === "pdf") {
        const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${profilePath}`;
        window.open(url, "_blank");
      } else {
        Snackbar("Unable to download Profile", "error");
      }
    }
  };

  const getFileColor = (path) => {
    if (!path) return "#a2a2a2";

    const ext = path.substring(path.lastIndexOf(".") + 1).toLowerCase();

    if (ext === "pdf") return "#F40009";
    if (ext === "doc" || ext === "docx") return "#0039a6";

    return "#a2a2a2"; // fallback for unknown types
  };

  const handleJobEdit = (item) => {
    navigate(`/jobpostedit/${item?.positionId}`, {
      state: {
        referrals: isReferral
      }
    });
  };

  return (
    <Box className="container">
      {showLoader ? <Loader /> : ""}
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
        }}
        onClick={handleNavigateBack}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          flexWrap: "wrap",
          marginTop: "15px",
        }}
      >
        <Typography className="title">
          {position
            ? position
            : positionTitle ||
            positionName ||
            jobPostingName ||
            clientNameManageEventReport}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          <MUICancelButton
            title="Share"
            onClick={handleShare}
            startIcon={
              <ShareOutlinedIcon sx={{ fontSize: "15px !important" }} />
            }
          />
          {isReferrals ? (
            <></>
          ) : (
            <Grid2>
              {bindingEditJobPosting?.response?.data?.map((item) => (
                <Tooltip
                  title={
                    Profile?.profile?.role === "admin"
                      ? item.status === "Active"
                        ? isReferral === "Y"
                          ? item.rewardType
                            ? item.candidateRewardType
                              ? "Add Candidate"
                              : "Candidate Reward is Missing"
                            : "Job Reward and Candidate Reward are Missing"
                          : item.candidateRewardType
                            ? "Add Candidate"
                            : "Candidate Reward is Missing"
                        : "We're sorry, but this job is currently inactive."
                      : item.status === "Active"
                        ? isReferral === "Y"
                          ? item.candidateRewardType
                            ? "Add Candidate"
                            : "You can't assign the candidate because the admin hasn't set the reward amount yet."
                          : item.candidateRewardType
                            ? "Add Candidate"
                            : "Candidate Reward is Missing"
                        : "We're sorry, but this job is currently inactive."
                  }
                  arrow
                  placement="bottom"
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#0A0D12",
                        borderRadius: "8px",
                        padding: "8px 12px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        // cursor:Profile?.profile?.role === 'admin'?'pointer':'not-allowed'
                      },
                    },
                  }}
                >
                  <Grid2>
                    <MUICancelButton
                      title="Add Candidates"
                      startIcon={<AddIcon />}
                      onClick={
                        Profile?.profile?.role === "admin"
                          ? item.status === "Active"
                            ? isReferral === "Y"
                              ? item.rewardType
                                ? item.candidateRewardType
                                  ? () => handleNavigateFindprofile(item)
                                  : null
                                : null
                              : item.candidateRewardType
                                ? () => handleNavigateFindprofile(item)
                                : null
                            : null
                          : item.status === "Active"
                            ? isReferral === "Y"
                              ? item.candidateRewardType
                                ? () => handleNavigateFindprofile(item)
                                : null
                              : item.candidateRewardType
                                ? () => handleNavigateFindprofile(item)
                                : null
                            : null
                      }
                      sx={{
                        cursor:
                          Profile?.profile?.role === "admin"
                            ? item.status !== "Active"
                              ? "not-allowed"
                              : isReferral === "Y"
                                ? item.rewardType
                                  ? item.candidateRewardType
                                    ? "pointer"
                                    : "not-allowed"
                                  : "not-allowed"
                                : item.candidateRewardType
                                  ? "pointer"
                                  : "not-allowed"
                            : item.status === "Active"
                              ? isReferral === "Y"
                                ? item.candidateRewardType
                                  ? "pointer"
                                  : "not-allowed"
                                : item.candidateRewardType
                                  ? "pointer"
                                  : "not-allowed"
                              : "not-allowed",
                        color: "#6941C6",
                        border: "1px solid ##D6BBFB",
                        width: "150px",
                      }}
                    />
                  </Grid2>
                </Tooltip>
              ))}
            </Grid2>
          )}
          {bindingEditJobPosting?.response?.data?.map((item) =>
            userRole === "recruiter" ? null : (
              <Grid2 onClick={(e) => handleJobEdit(item)} key={item.id}>
                <MUIButton title="Edit" className="edit-button" />
              </Grid2>
            )
          )}

          {/* {(isReferrals === true && userRole === "recruiter") ||
          isEdit === true ||
          pathName === "dashboard" ||
          findProfile === true ? (
            <></>
          ) : (
            <MUIButton
              title="Edit"
              className="edit-button"
              onClick={hanldeManageEventsNav}
            />
          )} */}
        </Box>
      </Box>

      <Box sx={{ width: "100%", typography: "body2" }}>
        {/* postion name  */}
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="Overview and Candidates tabs"
              textColor="primary"
              indicatorColor="secondary"
            >
              <Tab
                label="Overview"
                value="1"
                className="tabs"
                sx={{
                  textTransform: "none",
                  fontWeight: value === "1" ? "bold" : "normal",
                  transition: "all 0.3s ease",
                }}
              />
              {isReferrals ? (
                <></>
              ) : (
                <Tab
                  label="Candidates"
                  value="2"
                  className="tabs"
                  sx={{
                    textTransform: "none",
                    fontWeight: value === "2" ? "bold" : "normal",
                    transition: "all 0.3s ease",
                  }}
                />
              )}
            </TabList>
          </Box>

          {/* tabs  */}
          <TabPanel value="1" sx={{ display: "flex", padding: 1.5 }}>
            {bindingEditJobPosting?.response?.data?.map((Item) => (
              <div style={{ display: "flex", width: "100%", gap: "10px" }}>
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "50%",
                    rowGap: "5%",
                  }}
                >
                  {/* Your content */}
                  <Grid2
                    container
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>
                      <Typography
                        sx={{
                          color: "#181D27",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        Basic Information
                      </Typography>
                    </div>
                    <Box
                      style={{
                        display: !isSmallScreen ? "flex" : "",
                        gap: "20px",
                        marginTop: "10px",
                      }}
                    >
                      <Grid2
                        item
                        container
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          width: "50%",
                        }}
                        gap={2}
                      >
                        <Box>
                          <InputLabel>Priority</InputLabel>
                          <Typography
                            variant="body3"
                            sx={{
                              border: `1px solid ${Item?.priority === "High"
                                  ? "#FECDCA"
                                  : Item?.priority === "Low"
                                    ? "#D5D9EB"
                                    : "#FEDF89"
                                }`,
                              backgroundColor:
                                Item?.priority === "High"
                                  ? "#FEF3F2"
                                  : Item?.priority === "Low"
                                    ? "#F8F9FC"
                                    : "#FFFAEB",
                              padding: "1px 10px", // Added horizontal padding for better spacing
                              borderRadius: "10px",
                              color:
                                Item?.priority === "High"
                                  ? "#B42318"
                                  : Item?.priority === "Medium"
                                    ? "#B54708"
                                    : "#363F72",
                              textAlign: "center",
                              width: "65px",
                            }}
                          >
                            {Item?.priority}
                          </Typography>
                        </Box>

                        <Box>
                          <InputLabel>Status</InputLabel>
                          <Typography
                            variant="body3"
                            className={`badge-status ${Item?.status
                              ?.toLowerCase()
                              ?.replace(/\s+/g, "-")}`}
                          >
                            {Item?.status}
                          </Typography>
                        </Box>
                        {userRole === "recruiter" &&
                          pathName === "submitprofiles" ? (
                          <></>
                        ) : (
                          <>
                            <Box>
                              <InputLabel>Position ID</InputLabel>
                              <Typography variant="body3">
                                {Item?.positionId}
                              </Typography>
                            </Box>

                            <Box>
                              <InputLabel>Client Name</InputLabel>
                              <Typography variant="body3">
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    color: "#6941C6",
                                    fontWeight: 550,
                                    cursor: Item?.isMappedClient === "Y" ? "default" : "pointer"
                                  }}
                                  onClick={() => Item?.isMappedClient === "N" ?
                                    navigate(
                                      isReferrals
                                        ? `/referrals/client-edit/${Item?.clientId}`
                                        : `/client-edit/${Item?.clientId}`
                                    ) : null
                                  }
                                >
                                  {Item?.clientName}
                                  <NorthEastIcon
                                    sx={{ fontSize: 20, marginLeft: "4px" }}
                                  />
                                </Box>
                              </Typography>
                            </Box>
                          </>
                        )}

                        <Box>
                          <InputLabel>No. of Positions</InputLabel>
                          <Typography variant="body3">
                            {Item?.noOfPosition}
                          </Typography>
                        </Box>

                        <Box>
                          <InputLabel>Primary Skills</InputLabel>
                          <Box>
                            <Typography variant="body3">
                              {Item?.primarySkills || "-"}
                            </Typography>
                          </Box>
                        </Box>

                        <Box>
                          <InputLabel>Secondary Skills</InputLabel>
                          <Box>
                            <Typography variant="body3">
                              {Item?.secondarySkills || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid2>

                      <Grid2
                        item
                        container
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          width: "50%",
                        }}
                        gap={2}
                      >
                        <Box>
                          <InputLabel>Open Date</InputLabel>
                          <Typography variant="body3">
                            {formatDate(Item?.openDate)}
                          </Typography>
                        </Box>

                        {/* <Box>
                          <InputLabel>Close Date</InputLabel>
                          <Typography variant="body3">
                            {formatDate(Item?.closedDate)}
                          </Typography>
                        </Box> */}
                        <Box>
                          <InputLabel>Work Category</InputLabel>
                          <Typography variant="body3">
                            {Item?.workCategoryName}
                          </Typography>
                        </Box>
                        <Box>
                          <InputLabel>Position Level</InputLabel>
                          <Typography variant="body3">
                            {Item?.positionLevelName}
                          </Typography>
                        </Box>

                        <Box>
                          <InputLabel>Position Type</InputLabel>
                          <Typography variant="body3">
                            {Item?.positionType}
                          </Typography>
                        </Box>

                        <Box>
                          <InputLabel>Qualification</InputLabel>
                          <Box>
                            <Typography variant="body3">
                              {Item?.qualification === null
                                ? "-"
                                : Item?.qualification}
                            </Typography>
                          </Box>
                        </Box>
                        <Box>
                          <InputLabel>Fulfill Status</InputLabel>
                          <Box>
                            <Typography
                              sx={{ color: "#6941C6", fontWeight: 550 }}
                            >
                              {Item?.totalJoinedCount +
                                "/" +
                                Item?.noOfPosition}
                            </Typography>
                          </Box>
                        </Box>

                        <Box>
                          <InputLabel> {Item?.positionType === "Contract" ? "Maximun Billing Amount" : " Budgeted Cost"}</InputLabel>
                          <Typography variant="body3">
                            {Item?.budgetedCost === 0 ? (
                              "-"
                            ) : (
                              <>
                                {Item?.budgetCurrency === "INR" ? (
                                  <CurrencyRupeeIcon
                                    sx={{
                                      fontSize: "14px",
                                      position: "relative",
                                      top: "2px",
                                    }}
                                  />
                                ) : Item?.budgetCurrency === "USD" ? (
                                  <AttachMoneyOutlinedIcon
                                    sx={{
                                      fontSize: "14px",
                                      position: "relative",
                                      top: "2px",
                                    }}
                                  />
                                ) : Item?.budgetCurrency === "CAD" ? (
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      position: "relative",
                                      top: "3px",
                                    }}
                                  >
                                    <TbCurrencyDollarCanadian />
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      position: "relative",
                                      top: "2px",
                                    }}
                                  >
                                    <TbCurrencyDirham />
                                  </span>
                                )}
                                <span>
                                  {Item?.budgetedCost} /{" "}
                                  {Item?.budgetUnit === "Y"
                                    ? "Year"
                                    : Item?.budgetUnit === "M"
                                      ? "Month"
                                      : Item?.budgetUnit === "D"
                                        ? "Day"
                                        : Item?.budgetUnit === "H"
                                          ? "Hour"
                                          : "-"}
                                </span>
                              </>
                            )}
                          </Typography>
                        </Box>

                        <Box>
                          <InputLabel>Job Location</InputLabel>
                          <Box>
                            <Typography variant="body3">
                              {Item?.jobLocation === null
                                ? "-"
                                : Item?.jobLocation}
                            </Typography>
                          </Box>
                        </Box>

                        {/* <Box>
                                                    <InputLabel>Budgeted Currency</InputLabel>
                                                    <Box>
                                                        <Typography variant="body3">{Item?.budgetCurrency === null ? "-" : Item?.budgetCurrency}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box>
                                                    <InputLabel>Budgeted Unit</InputLabel>
                                                        <Typography variant="body3">
                                                            {Item?.budgetUnit === "Y"? "Year" : Item?.budgetUnit === "M"? "Month" : Item?.budgetUnit === "D"? "Day" : Item?.budgetUnit === "H"? "Hour" : "-"}
                                                        </Typography>
                                                </Box> */}
                      </Grid2>
                    </Box>
                  </Grid2>

                  <Grid2
                    container
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    {userRole === "recruiter" && isExternal === "N" ? (
                      <></>
                    ) : (
                      <Grid2
                        container
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "10px",
                        }}
                      >
                        <div>
                          <Typography
                            sx={{
                              color: "#181D27",
                              fontSize: "18px",
                              fontWeight: "bold",
                            }}
                          >
                            Commission Information
                          </Typography>
                        </div>
                        <div
                          style={{
                            display: !isSmallScreen ? "flex" : "",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          {userRole === "recruiter" ? (
                            <Grid2
                              item
                              container
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                              gap={2}
                            >
                              {pathName !== "submitprofiles" ? (
                                <Box>
                                  <InputLabel>Job Reward Type</InputLabel>
                                  <Typography variant="body3">
                                    {Item?.rewardType === null ||
                                      Item?.rewardType === ""
                                      ? "-"
                                      : Item?.rewardType === "FC"
                                        ? "Fixed Amount"
                                        : "Fixed Percentage"}
                                  </Typography>
                                </Box>
                              ) : (
                                <Box>
                                  <InputLabel>Candidate Reward Type</InputLabel>
                                  <Typography variant="body3">
                                    {Item?.candidateRewardType === null ||
                                      Item?.candidateRewardType === ""
                                      ? "-"
                                      : Item?.candidateRewardType === "FC"
                                        ? "Fixed Amount"
                                        : "Fixed Percentage"}
                                  </Typography>
                                </Box>
                              )}
                            </Grid2>
                          ) : (
                            <Grid2
                              item
                              container
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                              gap={2}
                            >
                              {isReferral === "Y" ? (
                                <Box>
                                  <InputLabel>Job Reward Type</InputLabel>
                                  <Typography variant="body3">
                                    {Item?.rewardType === ""
                                      ? "-"
                                      : Item?.rewardType === "FC"
                                        ? "Fixed Amount"
                                        : "Fixed Percentage"}
                                  </Typography>
                                </Box>
                              ) : (
                                <></>
                              )}

                              <Box>
                                <InputLabel>Candidate Reward Type</InputLabel>
                                <Typography variant="body3">
                                  {Item?.candidateRewardType === ""
                                    ? "-"
                                    : Item?.candidateRewardType === "FC"
                                      ? "Fixed Amount"
                                      : "Fixed Percentage"}
                                </Typography>
                              </Box>
                            </Grid2>
                          )}
                          {userRole === "recruiter" ? (
                            <Grid2
                              item
                              container
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                              gap={2}
                            >
                              {pathName !== "submitprofiles" ? (
                                Item?.rewardType === "FC" ? (
                                  <Box>
                                    <InputLabel>Reward (Rs.)</InputLabel>
                                    <Typography variant="body3">
                                      {Item?.rewardAmount || "-"}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box>
                                    <InputLabel>
                                      Reward{" "}
                                      {Item?.rewardType === "FP" ? "(%)" : ""}
                                    </InputLabel>
                                    <Typography variant="body3">
                                      {Item?.rewardPtc || "-"}
                                    </Typography>
                                  </Box>
                                )
                              ) : Item?.candidateRewardType === "FC" ? (
                                <Box>
                                  <InputLabel>Reward (Rs.)</InputLabel>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <CurrencyRupeeIcon
                                      sx={{
                                        fontSize: "14px",
                                        color: "#a6aba5",
                                      }}
                                    />
                                    <Typography sx={{ fontSize: "12.5px" }}>
                                      {Item?.candidateRewardAmount}
                                    </Typography>
                                  </Box>
                                </Box>
                              ) : (
                                <Box>
                                  <InputLabel>
                                    Reward{" "}
                                    {Item?.candidateRewardType === "FP"
                                      ? "(%)"
                                      : ""}
                                  </InputLabel>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "12.5px" }}>
                                      {Item?.candidateRewardPercentage !=
                                        null &&
                                        Item.candidateRewardPercentage !== ""
                                        ? `${Item.candidateRewardPercentage}%`
                                        : "-"}
                                    </Typography>
                                  </Box>
                                </Box>
                              )}
                            </Grid2>
                          ) : (
                            <>
                              <Grid2
                                item
                                container
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "50%",
                                }}
                                gap={2}
                              >
                                {isReferral === "Y" ? (
                                  Item?.rewardType === "FC" ? (
                                    <Box>
                                      <InputLabel>Reward (Rs.)</InputLabel>
                                      <Typography variant="body3">
                                        {Item?.rewardAmount || "-"}
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Box>
                                      <InputLabel>
                                        Reward{" "}
                                        {Item?.rewardType === "FP" ? "(%)" : ""}
                                      </InputLabel>
                                      <Typography variant="body3">
                                        {Item?.rewardPtc || "-"}
                                      </Typography>
                                    </Box>
                                  )
                                ) : (
                                  <></>
                                )}

                                {Item?.candidateRewardType === "FC" ? (
                                  <Box>
                                    <InputLabel>Reward (Rs.)</InputLabel>
                                    <Typography variant="body3">
                                      {Item?.candidateRewardAmount || "-"}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box>
                                    <InputLabel>
                                      Reward{" "}
                                      {Item?.candidateRewardType === "FP"
                                        ? "(%)"
                                        : ""}
                                    </InputLabel>
                                    <Typography variant="body3">
                                      {Item?.candidateRewardPercentage || "-"}
                                    </Typography>
                                  </Box>
                                )}
                              </Grid2>
                            </>
                          )}
                        </div>
                      </Grid2>
                    )}
                  </Grid2>

                  <Grid2
                    container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "10px",
                    }}
                  >
                    <div>
                      <Typography
                        sx={{
                          color: "#181D27",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        Co-ordinators{" "}
                        {userRole === "recruiter" ? "" : "& Recruiters"}
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: !isSmallScreen ? "flex" : "",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <Grid2
                        item
                        container
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          width: "50%",
                        }}
                        gap={1}
                      >
                        <InputLabel>Coordinator</InputLabel>
                        <Typography sx={{ color: "#000", fontSize: "14px" }}>
                          {Item?.coordinatorList
                            ?.filter((coordinator) => coordinator?.hasSelected)
                            ?.map((item) => item?.coordinatorName)
                            .join(", ") || "-"}
                        </Typography>
                      </Grid2>
                      {userRole !== "recruiter" && (
                        <Grid2
                          item
                          container
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                          gap={1}
                        >
                          <InputLabel>Recruiters</InputLabel>
                          <Typography sx={{ color: "#000", fontSize: "14px" }}>
                            {Item?.recruitersFullName
                              ?.map((data) => data)
                              .join(", ") || "-"}
                          </Typography>
                        </Grid2>
                      )}
                    </div>
                  </Grid2>
                </Grid2>

                <Grid2
                  container
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "50%",
                  }}
                >
                  <Grid2 sx={{ width: "100%", marginLeft: "20px" }}>
                    {/* <Box sx={{ marginBottom: '10px' }}>
                                            <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                                                Fullfilled Status
                                            </Typography>
                                            <Typography sx={{ fontSize: '12.5px' }}>
                                                {Item?.JoinedCount}
                                            </Typography>
                                        </Box> */}

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        marginLeft: "10px",
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#181D27",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        Job Description
                      </Typography>

                      <Box sx={{ width: "100%" }}>
                        <Typography
                          sx={{ fontSize: "16px", fontWeight: 600, mb: 1 }}
                        >
                          Overview
                        </Typography>

                        <Box
                          sx={{
                            fontSize: "14px",
                            lineHeight: "1.6",
                            whiteSpace: "pre-wrap",
                            maxHeight: "400px",
                            minHeight: "400px",
                            overflowY: "auto",
                            padding: "25px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "10px",
                            backgroundColor: "#fafafa",
                            marginLeft: "5px",
                            width: "95%",
                            // ✅ Custom scrollbar (thin, no arrows)
                            "&::-webkit-scrollbar": {
                              width: "6px",
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "#f1f1f1",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "#c1c1c1",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              backgroundColor: "#a0a0a0",
                            },
                          }}
                          component="div"
                          dangerouslySetInnerHTML={{
                            __html: Item?.jobDescription || "",
                          }}
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        marginTop: "15px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#181D27",
                          fontSize: "17px",
                          fontWeight: "bold",
                        }}
                      >
                        Remarks
                      </Typography>
                      <Typography sx={{ fontSize: "14px" }}>
                        {Item?.remarks || "No remarks....."}
                      </Typography>
                    </Box>
                  </Grid2>
                </Grid2>
              </div>
            ))}
          </TabPanel>

          {/* Second Tabs begining point... */}
          <TabPanel value="2" sx={{ " &.MuiTabPanel-root": { padding: 0 } }}>
            {profileListDatas?.length > 0 ? (
              <Box>
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "20px",
                  }}
                >
                  <Box sx={{ display: "flex", gap: "20px" }}>
                    <TextField
                      className="textfields"
                      size="small"
                      placeholder="Search here"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <SearchIconLg style={{ paddingRight: "5px" }} />
                          ),
                        },
                      }}
                      value={searchProfiles}
                      onChange={handleSearchProfileChange}
                      variant="outlined"
                    />

                    <Dropdown
                      style={{ width: "220px" }} // Use style for inline styles
                      placeholder="Select Event Type"
                      labelKey="event"
                      valueKey="eventTypeId"
                      value={eventType || ""}
                      onChange={(value) => handleEventTypeChange(value)}
                      options={eventDropDown?.response || []}
                    />
                  </Box>

                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px",
                    }}
                  >
                    <Box sx={{ display: "flex", gap: "20px" }}>
                      <MUICancelButton
                        title="Send Email"
                        sx={{
                          color:
                            profileMatchDatas?.length === 0
                              ? "#a2a2a2"
                              : "black !important",
                        }}
                        onClick={handleMailContent}
                        disabled={profileMatchDatas?.length === 0}
                      />
                      <MUIButton
                        title="Download"
                        sx={{ width: "130px" }}
                        onClick={handleProfileMatchExcelDownload}
                        startIcon={<DownloadIcon stroke={"white"} />}
                      ></MUIButton>
                    </Box>

                    {/* 
                                        <Box sx={{ display: 'flex', gap: '20px' }}>
                                            <MUICancelButton
                                                title="Manage Events"
                                                sx={{
                                                    color: 'black !important',
                                                }}
                                                onClick={hanldeManageEventsNav}
                                            />
                                            <MUICancelButton title="Find Profile" onClick={handleNavigateFindprofile} sx={{ width: '150px' }}   ></MUICancelButton>
                                        </Box> */}
                  </Grid2>
                </Grid2>

                {/* desgin box */}
                <Grid2 sx={{ marginTop: "10px" }}>
                  {profileListDatas_2?.length > 0 ? (
                    profileListDatas_2?.map((item, index) => {
                      const actualIndex = (page - 1) * rowsPerPage + index;
                      return (
                        <Accordion
                          expanded={accordionOpen?.includes(actualIndex)}
                          sx={{
                            "&:before": {
                              display: "none",
                            },
                            marginBottom: "5px",
                            border: "1px solid #E9EAEB",
                            borderRadius: "10px",
                          }}
                          elevation={0}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{ cursor: "pointer", color: "#000000" }}
                                onClick={() => handleExpandAccordion(index)}
                              />
                            }
                            sx={{
                              alignItems: "flex-start",
                              cursor: "unset !important",
                              "& .MuiAccordionSummary-expandIconWrapper": {
                                position: "absolute",
                                right: 12,
                                top: 16,
                              },
                            }}
                          >
                            <Grid2
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "flex-end",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    marginRight: "30px",
                                  }}
                                >
                                  <Typography
                                    className={`evenType ${item?.eventType
                                      ?.toLowerCase()
                                      ?.replace(/\s+/g, "-")}`}
                                  >
                                    {item?.eventType}
                                  </Typography>

                                  <Box
                                    className={`badgeGroup ${item?.eventType
                                      ?.toLowerCase()
                                      ?.replace(/\s+/g, "-")}`}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "4px",
                                      }}
                                    >
                                      <Box
                                        className={`msgBox ${item?.eventType
                                          ?.toLowerCase()
                                          ?.replace(/\s+/g, "-")}`}
                                      >
                                        {badgeMessages[index]?.message && (
                                          <Typography
                                            key={index}
                                            sx={{ fontSize: "12px" }}
                                          >
                                            {badgeMessages[index]?.message}
                                          </Typography>
                                        )}
                                      </Box>
                                      {days[index]?.day && (
                                        <Typography
                                          className={`msgText ${item?.eventType
                                            ?.toLowerCase()
                                            ?.replace(/\s+/g, "-")}`}
                                          key={index}
                                          sx={{ fontSize: "12px" }}
                                        >
                                          {days && days?.[index].day}{" "}
                                          {`${days?.[index].day === 1
                                              ? "day ago"
                                              : "days ago"
                                            }`}
                                        </Typography>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>

                              <Grid2
                                sx={{
                                  marginTop: "10px",
                                  display: "flex",
                                  flexWrap: "wrap",
                                }}
                              >
                                <Grid2
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    flexDirection: isSmallScreen && "column",
                                    justifyContent: "space-evenly",
                                  }}
                                  gap={isSmallScreen ? 1 : 0}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "60px",
                                      alignContent: "flex-start",
                                      width: "60%",
                                    }}
                                  >
                                    <Box sx={{ width: "40%" }}>
                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#181D27",
                                          fontSize: "15px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {item?.firstName} {item?.lastName}{" "}
                                      </Typography>
                                      <InputLabel
                                        sx={{ fontSize: "13px !important" }}
                                      >
                                        Email
                                      </InputLabel>
                                      <Typography
                                        sx={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          color: "#6941C6",
                                          fontWeight: 550,
                                          cursor: "pointer",
                                          fontSize: "12.5px",
                                        }}
                                        onClick={() =>
                                          handleEditCandidateNav(item)
                                        }
                                      >
                                        {item?.email}
                                        <NorthEastIcon
                                          sx={{
                                            fontSize: 18,
                                            marginLeft: "4px",
                                          }}
                                        />
                                      </Typography>
                                    </Box>
                                    <Box sx={{ width: "30%" }}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                          marginBottom: "4px",
                                        }}
                                      >
                                        <Tooltip
                                          placement="top"
                                          title={
                                            item?.cVPath === null
                                              ? "No profile uploaded for this candidate."
                                              : "Download Resume"
                                          }
                                          slotProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: "#0A0D12",
                                                color: "#fff",
                                                borderRadius: "8px",
                                                boxShadow:
                                                  "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                              },
                                            },
                                          }}
                                        >
                                          <Box
                                            onClick={() =>
                                              item?.cVPath &&
                                              handleDownloadProfile(item)
                                            }
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                              borderRadius: "6px",
                                              cursor: item?.cVPath
                                                ? "pointer"
                                                : "not-allowed",
                                              backgroundColor: "transparent",
                                              "&:hover": {
                                                backgroundColor: item?.cVPath
                                                  ? "#F5F5F5"
                                                  : "transparent",
                                              },
                                            }}
                                          >
                                            <DescriptionIcon
                                              sx={{
                                                color: getFileColor(
                                                  item?.cVPath
                                                ),
                                                fontSize: 20,
                                              }}
                                            />
                                            <Typography
                                              sx={{
                                                fontSize: 13,
                                                color: getFileColor(
                                                  item?.cVPath
                                                ),
                                                fontWeight: 500,
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {item?.firstName}.Resume
                                            </Typography>
                                          </Box>
                                        </Tooltip>
                                      </Box>
                                      <InputLabel
                                        sx={{ fontSize: "13px !important" }}
                                      >
                                        Phone
                                      </InputLabel>
                                      <Typography
                                        sx={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          color: "#6941C6",
                                          fontWeight: 550,
                                          cursor: "pointer",
                                          fontSize: "12.5px",
                                        }}
                                        onClick={() =>
                                          handleEditCandidateNav(item)
                                        }
                                      >
                                        {item?.mobileNumber}
                                        <NorthEastIcon
                                          sx={{
                                            fontSize: 20,
                                            marginLeft: "4px",
                                          }}
                                        />
                                      </Typography>
                                    </Box>
                                  </div>
                                  <div
                                    style={{
                                      borderRight: "1px solid #D5D7DA",
                                      padding: !isSmallScreen && "20px",
                                    }}
                                  />

                                  <Box
                                    sx={{
                                      width: "30%",
                                      padding: !isSmallScreen && "1px 30px",
                                    }}
                                  >
                                    <InputLabel
                                      sx={{ fontSize: "13px !important" }}
                                    >
                                      Technologies
                                    </InputLabel>
                                    <Typography
                                      sx={{
                                        fontSize: "12.5px",
                                        color: "#414651",
                                      }}
                                    >
                                      {item?.technologies
                                        ?.map((tech) => tech?.itemName)
                                        .join(", ")}
                                    </Typography>
                                  </Box>
                                  <div
                                    style={{ borderRight: "1px solid #D5D7DA" }}
                                  ></div>

                                  <Grid2
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: !isSmallScreen && "1px 30px",
                                      width: "30%",
                                    }}
                                  >
                                    <ThemeProvider theme={theme}>
                                      <Checkbox
                                        checked={profileMatchDatas?.includes(
                                          item?.profileMatchId
                                        )}
                                        onChange={() =>
                                          handleProfileCheckbox(
                                            item?.profileMatchId
                                          )
                                        }
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 17.5, // Adjust this value to decrease the checkbox size
                                          },
                                        }}
                                        defaultChecked
                                        color="checked"
                                      />
                                    </ThemeProvider>
                                    <Typography
                                      sx={{
                                        fontSize: "12.5px",
                                        color: "#414651",
                                      }}
                                    >
                                      {item?.eventType}
                                    </Typography>
                                  </Grid2>
                                </Grid2>
                              </Grid2>
                            </Grid2>
                          </AccordionSummary>

                          {/* 3rd grid */}
                          <AccordionDetails>
                            <Grid2
                              sx={{ display: "flex", marginBottom: "10px" }}
                            >
                              <Grid2
                                sx={{
                                  display: "flex",
                                  width: "100%",
                                  flexDirection: isSmallScreen && "column",
                                }}
                                gap={isSmallScreen ? 1 : 0}
                              >
                                <div style={{ display: "flex", gap: "60px" }}>
                                  <Box>
                                    <InputLabel
                                      sx={{ fontSize: "13px !important" }}
                                    >
                                      Total Experience
                                    </InputLabel>
                                    <Typography
                                      sx={{
                                        fontSize: "12.5px",
                                        color: "#414651",
                                      }}
                                    >
                                      {item?.totalExperience
                                        ? item?.totalExperience
                                        : "N/A"}
                                    </Typography>
                                  </Box>

                                  <Box>
                                    <InputLabel
                                      sx={{ fontSize: "13px !important" }}
                                    >
                                      Relevant Experience
                                    </InputLabel>
                                    <Typography
                                      sx={{
                                        fontSize: "12.5px",
                                        color: "#414651",
                                      }}
                                    >
                                      {item?.relevantExperience
                                        ? item?.relevantExperience
                                        : "N/A"}
                                    </Typography>
                                  </Box>
                                </div>
                                <div
                                  style={{
                                    borderRight: "1px solid #D5D7DA",
                                    padding: !isSmallScreen && "20px",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    gap: "60px",
                                    padding: !isSmallScreen && "1px 30px",
                                    width: "auto",
                                  }}
                                >
                                  <Box>
                                    <InputLabel
                                      sx={{ fontSize: "13px !important" }}
                                    >
                                      CCTC
                                    </InputLabel>
                                    <Typography
                                      sx={{
                                        fontSize: "12.5px",
                                        color: "#414651",
                                      }}
                                    >
                                      {item?.candidateCCTC}
                                    </Typography>
                                  </Box>

                                  <Box>
                                    <InputLabel
                                      sx={{ fontSize: "13px !important" }}
                                    >
                                      ECTC
                                    </InputLabel>
                                    <Typography
                                      sx={{
                                        fontSize: "12.5px",
                                        color: "#414651",
                                      }}
                                    >
                                      {item?.candidateECTC}
                                    </Typography>
                                  </Box>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    borderRight: "1px solid #D5D7DA",
                                  }}
                                ></div>

                                <Box
                                  sx={{ padding: !isSmallScreen && "1px 30px" }}
                                >
                                  <InputLabel
                                    sx={{ fontSize: "13px !important" }}
                                  >
                                    Notice Period
                                  </InputLabel>
                                  <Typography sx={{ fontSize: "12.5px" }}>
                                    {item?.noticePeriod}
                                  </Typography>
                                </Box>
                              </Grid2>
                            </Grid2>

                            <Grid2
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "20px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <MUICancelButton
                                  title="History"
                                  onClick={() => handleHistoryDialogOpen(item)}
                                  startIcon={<RefreshIcon stroke={"#414651"} />}
                                  sx={{ width: "100px" }}
                                />
                                {item?.eventTypeId === 1 &&
                                  (Profile?.profile?.role === "admin" ||
                                    Profile?.profile?.role ===
                                    "coordinator") && (
                                    <MUIButton
                                      title="Unassign Profile"
                                      onClick={() =>
                                        handleUnassignProfile(item)
                                      }
                                      startIcon={<UsersXIcon stroke={"#fff"} />}
                                      sx={{
                                        width: "155px",
                                        color: "#ffffff",
                                        backgroundColor: "#D92D20",
                                        shadows: "#0A0D120D",
                                        fontSize: "12px",
                                      }}
                                    />
                                  )}
                              </Box>
                            </Grid2>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  ) : (
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10}>
                            <Typography className="emptydatas">
                              No Data Found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  )}
                  {Math.ceil(totalCount / rowsPerPage) > 1 && (
                    <Table>
                      <TableRow>
                        <TableCell colSpan={100}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <MUICancelButton
                              title="Previous"
                              startIcon={
                                <ArrowBackIcon
                                  sx={{
                                    color: page === 1 ? "#a2a2a2" : "#414651",
                                  }}
                                />
                              }
                              disabled={page === 1}
                              onClick={() => handlePageChange(null, page - 1)}
                              sx={{ height: "36px" }}
                            />

                            <Pagination
                              page={page}
                              onChange={handlePageChange}
                              count={Math.ceil(totalCount / rowsPerPage)}
                              siblingCount={1}
                              boundaryCount={1}
                              shape="rounded"
                              hidePrevButton
                              hideNextButton
                            />

                            <MUICancelButton
                              title="Next"
                              startIcon={
                                <ArrowForwardIcon
                                  sx={{
                                    color:
                                      page ===
                                        Math.ceil(totalCount / rowsPerPage)
                                        ? "#a2a2a2"
                                        : "#414651",
                                  }}
                                />
                              }
                              onClick={() => handlePageChange(null, page + 1)}
                              disabled={
                                page === Math.ceil(totalCount / rowsPerPage)
                              }
                              sx={{ height: "36px" }}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    </Table>
                  )}
                </Grid2>
              </Box>
            ) : (
              <Box>
                {bindingEditJobPosting?.response?.data?.map((item) => (
                  <Grid2
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Grid2
                      container
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        border: "1px solid #D5D7DA",
                        width: "550px",
                        height: "460px",
                        borderRadius: "12px",
                      }}
                    >
                      <Box
                        sx={{
                          border: "1px solid #E9EAEB",
                          width: "288px",
                          height: "288px",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            border: "1px solid #E9EAEB",
                            width: "224px",
                            height: "224px",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              border: "1px solid #E9EAEB",
                              width: "160px",
                              height: "160px",
                              borderRadius: "50%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                border: "1px solid #E9EAEB",
                                width: "96px",
                                height: "96px",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  border: "1px solid #E9EAEB",
                                  width: "48px",
                                  height: "48px",
                                  borderRadius: "10px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Typography>{<SearchIconLg />}</Typography>
                                <Box
                                  sx={{
                                    position: "absolute",
                                    width: "512px",
                                    height: "200px",
                                    marginTop: "335px",
                                    display: "flex",
                                    gap: "30px",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "352px",
                                      height: "68px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "20px",
                                    }}
                                  >
                                    <Typography sx={{ textAlign: "center" }}>
                                      <span style={{ fontWeight: "bold" }}>
                                        {" "}
                                        No candidates assigned to this job yet{" "}
                                      </span>
                                      <br></br>
                                      Candidates will be added once Job has been
                                      created.
                                    </Typography>
                                    <Tooltip
                                      title={
                                        Profile?.profile?.role === "admin"
                                          ? item.status === "Active"
                                            ? isReferral === "Y"
                                              ? item.rewardType
                                                ? item.candidateRewardType
                                                  ? "Add Candidate"
                                                  : "Candidate Reward is Missing"
                                                : "Job Reward and Candidate Reward are Missing"
                                              : item.candidateRewardType
                                                ? "Add Candidate"
                                                : "Candidate Reward is Missing"
                                            : "We're sorry, but this job is currently inactive."
                                          : item.status === "Active"
                                            ? isReferral === "Y"
                                              ? item.candidateRewardType
                                                ? "Add Candidate"
                                                : "You can't assign the candidate because the admin hasn't set the reward amount yet."
                                              : item.candidateRewardType
                                                ? "Add Candidate"
                                                : "Candidate Reward is Missing"
                                            : "We're sorry, but this job is currently inactive."
                                      }
                                      arrow
                                      placement="bottom"
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: "#0A0D12",
                                            borderRadius: "8px",
                                            padding: "8px 12px",
                                            boxShadow:
                                              "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                            // cursor:Profile?.profile?.role === 'admin'?'pointer':'not-allowed'
                                          },
                                        },
                                      }}
                                    >
                                      <Button
                                        className="add-button-2"
                                        startIcon={<AddIcon />}
                                        onClick={
                                          Profile?.profile?.role === "admin"
                                            ? item.status === "Active"
                                              ? isReferral === "Y"
                                                ? item.rewardType
                                                  ? item.candidateRewardType
                                                    ? () =>
                                                      handleNavigateFindprofile(
                                                        item
                                                      )
                                                    : null
                                                  : null
                                                : item.candidateRewardType
                                                  ? () =>
                                                    handleNavigateFindprofile(
                                                      item
                                                    )
                                                  : null
                                              : null
                                            : item.status === "Active"
                                              ? isReferral === "Y"
                                                ? item.candidateRewardType
                                                  ? () =>
                                                    handleNavigateFindprofile(
                                                      item
                                                    )
                                                  : null
                                                : item.candidateRewardType
                                                  ? () =>
                                                    handleNavigateFindprofile(
                                                      item
                                                    )
                                                  : null
                                              : null
                                        }
                                        sx={{
                                          cursor:
                                            Profile?.profile?.role === "admin"
                                              ? item.status !== "Active"
                                                ? "not-allowed"
                                                : isReferral === "Y"
                                                  ? item.rewardType
                                                    ? item.candidateRewardType
                                                      ? "pointer"
                                                      : "not-allowed"
                                                    : "not-allowed"
                                                  : item.candidateRewardType
                                                    ? "pointer"
                                                    : "not-allowed"
                                              : item.status === "Active"
                                                ? isReferral === "Y"
                                                  ? item.candidateRewardType
                                                    ? "pointer"
                                                    : "not-allowed"
                                                  : item.candidateRewardType
                                                    ? "pointer"
                                                    : "not-allowed"
                                                : "not-allowed",
                                        }}
                                      >
                                        {" "}
                                        Add Candidates
                                      </Button>
                                    </Tooltip>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Grid2>
                  </Grid2>
                ))}
              </Box>
            )}
          </TabPanel>
        </TabContext>

        <Grid2>
          <Dialog
            sx={{
              "& .MuiDialog-paper": {
                minWidth: "65vw",
                minHeight: "80vh",
              },
              marginLeft: "75px",
            }}
            open={historyDialogOpen}
            onClose={handleHistoryDialogClose}
          >
            <DialogTitle variant="h6">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography className="title">History</Typography>
                <CloseIcon
                  sx={{ cursor: "pointer" }}
                  onClick={handleHistoryDialogClose}
                ></CloseIcon>
              </Box>
            </DialogTitle>

            <DialogContent dividers>
              <DialogContentText>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHeadersCell">Date</TableCell>
                      <TableCell className="tableHeadersCell">
                        Client Name
                      </TableCell>
                      <TableCell className="tableHeadersCell">
                        Job Title
                      </TableCell>
                      <TableCell className="tableHeadersCell">Event</TableCell>
                      <TableCell className="tableHeadersCell">Notes</TableCell>
                      <TableCell className="tableHeadersCell">
                        Processed By
                      </TableCell>
                      <TableCell className="tableHeadersCell">Action</TableCell>
                    </TableRow>
                  </TableHead>

                  {historyTableDatas?.length > 0 ? (
                    <TableBody>
                      {historyTableDatas?.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell className="tableBodyCell">
                            {item?.date
                              ? dayjs(item?.date).format(
                                "DD/MM/YYYY hh:mm:ss A"
                              )
                              : "NA"}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.clientName}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.jobTitile}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.event}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.notes ? item?.notes : "NA"}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.processedBy}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            <IconButton disabled={!item?.deletable}>
                              <DeleteIcon
                                stroke={item?.deletable ? "red" : "#a2a2a2"}
                                onClick={(e) =>
                                  item?.deletable && hanldeMiniDialogOpen(item)
                                }
                                style={{
                                  cursor: !item?.deletable && "not-allowed",
                                  pointerEvents: "auto",
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={8}>
                          <Typography className="emptydatas">
                            No Data Found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MUICancelButton
                title="Close"
                onClick={handleHistoryDialogClose}
              ></MUICancelButton>
            </DialogActions>
          </Dialog>

          <Grid2 item>
            <Dialog
              open={MinihistoryDialogOpen}
              onClose={handleCloseDelete}
              scroll="paper"
              maxWidth="xs"
              sx={{
                "& .MuiDialog-paper": {
                  width: "90%",
                  maxWidth: "550px",
                  height: "auto",
                  borderRadius: "15px",
                },
              }}
            >
              <DialogContent>
                <DialogContentText>
                  <div
                    style={{ display: "flex", gap: "12px", marginTop: "7px" }}
                  >
                    <div
                      style={{
                        backgroundColor: "#FEE4E2",
                        borderRadius: "40px",
                        height: "40px",
                        width: "45px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <DeleteIcon stroke={"red"} />
                    </div>

                    <div>
                      <Typography
                        sx={{
                          color: "#181D27",
                          fontWeight: 600,
                          fontSize: "17px",
                        }}
                      >
                        Delete Job?
                      </Typography>
                      <Typography
                        sx={{
                          color: "#535862",
                          fontWeight: 400,
                          fontSize: "14px",
                        }}
                      >
                        Are you sure you want to delete this post? This action
                        cannot be undone.
                      </Typography>
                    </div>
                  </div>
                  <Grid2
                    item
                    sx={{
                      marginTop: "25px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "flex-end",
                    }}
                  >
                    <MUICancelButton
                      title="Cancel"
                      onClick={() => setMinihistoryDialogOpen(false)}
                    />
                    <MUIButton
                      title="Delete"
                      sx={{ backgroundColor: "#D92D20", borderRadius: "10px" }}
                      onClick={handleHistoryDelete}
                    />
                  </Grid2>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </Grid2>
        </Grid2>

        <Grid2>
          <Dialog
            open={openMailDialog}
            onClose={handleMailDialogClose}
            scroll="paper"
            maxWidth="md"
            sx={{
              "& .MuiDialog-paper": {
                minWidth: "50vw",
                minHeight: "80vh",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: 600,
                fontSize: "18px",
              }}
            >
              {excelPath || zipFile
                ? "Email to Client"
                : `Job Description for ${position}`}
              <CloseIcon
                sx={{ color: "#717680", cursor: "pointer" }}
                onClick={handleMailDialogClose}
              />
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                <Grid2
                  container
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Grid2
                    item
                    sx={{ display: "flex", flexGrow: 1, alignItems: "center" }}
                  >
                    <InputLabel
                      className="inputlabels"
                      sx={{ width: "13%", fontWeight: "bold" }}
                    >
                      To:
                    </InputLabel>
                    <TextField
                      value={mailTo}
                      onChange={handleMailToChange}
                      size="small"
                      className="textfields"
                      placeholder="Enter Mail Id (separate multiple with commas)"
                      sx={{ width: "55% !important" }}
                      error={mailTo && !isEmailValid}
                      helperText={
                        mailTo && !isEmailValid
                          ? "Please enter valid email addresses"
                          : ""
                      }
                    />
                  </Grid2>

                  <Grid2
                    item
                    sx={{
                      display: "flex",
                      flexGrow: 1,
                      alignItems: "center",
                      marginTop: "30px",
                    }}
                  >
                    <InputLabel
                      className="inputlabels"
                      sx={{ width: "13%", fontWeight: "bold" }}
                    >
                      Subject:
                    </InputLabel>
                    <TextField
                      value={mailSubject}
                      onChange={handleMailSubjectChange}
                      size="small"
                      className="textfields"
                      placeholder="Enter Subject"
                      sx={{ width: "55% !important" }}
                    />
                  </Grid2>

                  <Grid2 item sx={{ marginTop: "30px" }}>
                    <ReactQuill
                      value={mailBodycontent}
                      onChange={handleBodyContentChange}
                      formats={formats}
                      modules={toolBarOptions}
                      placeholder="Start typing here..."
                      style={{ color: "#000000" }}
                    />
                  </Grid2>
                </Grid2>

                {profileZip && zipFile ? (
                  <Box>
                    <Grid2
                      item
                      sx={{
                        display: "flex",
                        marginTop: "20px",
                        alignItems: "center",
                        gap: "3px",
                      }}
                    >
                      <TopicIcon sx={{ color: "green" }} />
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#0072b0",
                          cursor: "pointer",
                        }}
                        onClick={handleExcelDownload}
                      >
                        {" "}
                        {zipFile?.substring(zipFile?.lastIndexOf("/") + 1)}
                      </Typography>
                    </Grid2>

                    <Grid2
                      item
                      sx={{
                        display: "flex",
                        marginTop: "15px",
                        alignItems: "center",
                        gap: "3px",
                      }}
                    >
                      <FolderZipIcon sx={{ color: "GoldenRod" }} />
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#0072b0",
                          cursor: "pointer",
                        }}
                        onClick={handleZipFileDownload}
                      >
                        {profileZip?.substring(
                          profileZip?.lastIndexOf("/") + 1
                        )}
                      </Typography>
                    </Grid2>
                  </Box>
                ) : (
                  ""
                )}

                <Grid2
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <MUIButton
                    title="Send"
                    sx={{ backgroundColor: "#7F56D9" }}
                    onClick={handleSendEmailToClient}
                    disabled={
                      !mailTo ||
                      !isEmailValid ||
                      !mailSubject ||
                      !mailBodycontent.replace(/<[^>]*>?/gm, "").trim()
                    }
                  />
                </Grid2>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Grid2>

        <Modal open={openShareDialog} onClose={handleCloseShare}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 300,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                cursor: "pointer",
              }}
              onClick={handleCloseShare}
            >
              <Tooltip
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#0A0D12",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    },
                  },
                }}
                title="close"
              >
                <CloseOutlinedIcon />
              </Tooltip>
            </div>
            <Typography
              variant="h6"
              className="title"
              sx={{ borderBottom: "1px solid #000000" }}
            >
              Share options
            </Typography>
            <List>
              {socialIcons.map((social, index) => {
                if (social.label === "Copy link") {
                  return (
                    <ListItem
                      button
                      key={index}
                      onClick={social.onClick}
                      sx={{ cursor: "pointer" }}
                    >
                      <ListItemIcon
                        sx={{ minWidth: "auto", marginRight: "8px" }}
                      >
                        {social.icon}
                      </ListItemIcon>
                      <ListItemText primary={social.label} />
                    </ListItem>
                  );
                } else {
                  const ShareButtonComponent = social.component;
                  return (
                    <ListItem
                      button
                      key={index}
                      onClick={() => getJdEmail(social)}
                    >
                      <ShareButtonComponent
                        url={currentUrl}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <ListItemIcon
                          sx={{ minWidth: "auto", marginRight: "8px" }}
                        >
                          {social.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={social.label}
                          sx={{ cursor: "pointer" }}
                        />
                      </ShareButtonComponent>
                    </ListItem>
                  );
                }
              })}
            </List>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};
export default ViewJob;
